import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { commonService } from '../../services/commonService';

export const useGetDecisionWidget = ({ placement, amount, enabled = true }) =>
  useQuery({
    staleTime: 1000 * 3,
    refetchOnWindowFocus: true,
    queryKey: [QUERY_KEYS.common.decision_widget, placement, amount ?? null],
    queryFn: () =>
      commonService.decisionWidget({ placement, amount }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
    enabled,
  });